import React, { useEffect } from 'react';
import '../MarketingTemplate/MarketingTemplateTwo.css';
import coverImg from '../../assets/images/Ladakh.jpg';
import secondCoverImg from '../../assets/images/Ladakh.jpg';

function MarketingTemplateTwo() {
    useEffect(() => {
        window.scrollTo(0, 0);

        // Observer for journey map animations
        const journeyMap = document.querySelector('.journey-map');
        const descriptions = document.querySelectorAll('.day-description-landing');

        const journeyObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Animate all day descriptions when journey map comes into view
                    descriptions.forEach((desc, index) => {
                        setTimeout(() => {
                            desc.classList.add('animate');
                        }, index * 500); // Animate one-by-one with delay
                    });
                    journeyObserver.unobserve(entry.target); // Stop observing once animated
                }
            });
        }, { 
            threshold: 0.2, // Trigger when 20% of the journey map is visible
            rootMargin: '-100px 0px -100px 0px' // Add margin to delay the trigger
        });

        // Observer for first para animations
        const firstPara = document.querySelector('.first-para');
        const firstParaTitle = document.querySelector('.first-para-msg-title');
        const firstParaMsg = document.querySelector('.msg');

        const firstParaObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Animate title first, then message
                    setTimeout(() => {
                        if (firstParaTitle) {
                            firstParaTitle.classList.add('animate');
                        }
                    }, 200);
                    
                    setTimeout(() => {
                        if (firstParaMsg) {
                            firstParaMsg.classList.add('animate');
                        }
                    }, 700); // 500ms delay after title animation
                    
                    firstParaObserver.unobserve(entry.target); // Stop observing once animated
                }
            });
        }, { 
            threshold: 0.3, // Trigger when 30% of the first para is visible
            rootMargin: '-50px 0px -50px 0px' // Add margin to delay the trigger
        });

        // Start observing
        if (journeyMap) {
            journeyObserver.observe(journeyMap);
        }

        if (firstPara) {
            firstParaObserver.observe(firstPara);
        }

        return () => {
            if (journeyMap) {
                journeyObserver.unobserve(journeyMap);
            }
            if (firstPara) {
                firstParaObserver.unobserve(firstPara);
            }
        };
    }, []);

    return (
        <div className='container-fluid marketing-two'>
            <div className='img-container'>
                <img className='img-style' src={coverImg} alt="Ladakh Package" />
                <div className='cover-img-caption'>
                    <div className='package-name'>Test For Final Sample A Short Escape to Serenity</div>
                    <div className='package-days'>5 Days | 4 Nights</div>
                    <div className='package-price'>₹ 7777</div>
                </div>
            </div>

            <div className='container'>
                <div className='first-para mt-5'>
                    <div className='first-title text-center'>WE ARE THE BEST</div>
                    <div className='first-para-msg mt-3'>
                        <div className='first-para-msg-title text-center'>About the package</div>
                        <div className='msg mt-2'>
                            Our Himalayan Adventure package is a thrilling journey through the snow-capped peaks and scenic landscapes of the Himalayas.
                            Enjoy a unique blend of adventure and relaxation with expert guides and luxurious accommodations.
                        </div>
                    </div>
                </div>

                <div className='second-coverImg-container mt-5'>
                    <img className='second-coverImg' src={secondCoverImg} alt="Second" />
                </div>
                <div className='second-title mt-5'>
                    <div className='itinerary-title'>Itinerary Route</div>
                    <div className='journeyplan-title'>Journey Plan</div>

                    <div className='journey-map'>
                        <div className="vertical-line-days"></div>
                        <div className='card'>
                            <div className='card-body day-description-landing'>
                                <div className='day-title'>Day 1</div>
                                <div className='day-details'>Sightseeing in Kathmandu including Swayambhunath, Boudhanath, and Pashupatinath.</div>
                            </div>
                        </div>
                        <div className='card'>
                            <div className='card-body day-description-landing'>
                                <div className='day-title'>Day 2</div>
                                <div className='day-details'>Sightseeing in Kathmandu including Swayambhunath, Boudhanath, and Pashupatinath.</div>
                            </div>
                        </div>
                        <div className='card'>
                            <div className='card-body day-description-landing'>
                                <div className='day-title'>Day 3</div>
                                <div className='day-details'>Sightseeing in Kathmandu including Swayambhunath, Boudhanath, and Pashupatinath.</div>
                            </div>
                        </div>
                        <div className='card'>
                            <div className='card-body day-description-landing'>
                                <div className='day-title'>Day 4</div>
                                <div className='day-details'>Sightseeing in Kathmandu including Swayambhunath, Boudhanath, and Pashupatinath.</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='card'>
                    <div className='card-header text-center'>Inclusions</div>
                    <div className='card-body mt-3'>
                        <ul className='inclusionlist'>
                            <li><i className="bi bi-check-lg"></i> 7 days/6 nights in luxurious accommodations</li>
                            <li><i className="bi bi-check-lg"></i> Guided trek to Mount Everest base camp</li>
                            <li><i className="bi bi-check-lg"></i> Airport transfers and all travel arrangements</li>
                            <li><i className="bi bi-check-lg"></i> All meals and beverages included</li>
                            <li><i className="bi bi-check-lg"></i> Professional photography package</li>
                        </ul>
                    </div>
                </div>

                <div className='card mt-5'>
                    <div className='card-header text-center'>Exclusions</div>
                    <div className='card-body mt-3'>
                        <ul className='inclusionlist'>
                            <li><i className="bi bi-x-lg"></i> Personal insurance and expenses</li>
                            <li><i className="bi bi-x-lg"></i> International flight tickets</li>
                            <li><i className="bi bi-x-lg"></i> Visa fees</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MarketingTemplateTwo;